import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Tooltip from '@mui/material/Tooltip';

// Annotate a text with glossary terms. Case-insensitive match, preserves original casing.
// glossary object expected: { set: Set<string>, byTerm: Map(term -> {definition, example}), terms?: sorted array }
// language: 'ES' or 'EN' to determine the example label
export function annotateGlossaryText(glossary, text, language = 'ES') {
  if (!text || !glossary || !glossary.set || glossary.set.size === 0) return text;
  const terms = glossary.terms ? glossary.terms.slice() : Array.from(glossary.set).sort((a,b)=>b.length-a.length);
  const escaped = terms.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  if (!escaped.length) return text;
  const re = new RegExp(`(^|[^A-Za-zÁÉÍÓÚáéíóúÜüÑñ0-9])(${escaped.join('|')})(?=$|[^A-Za-zÁÉÍÓÚáéíóúÜüÑñ0-9])`, 'giu');
  const pieces = [];
  let cursor = 0; let m;
  const exampleLabel = language === 'EN' ? 'Example:' : 'Ejemplo:';
  
  while ((m = re.exec(text)) !== null) {
    const fullIndex = m.index;
    const boundaryLen = m[1] ? m[1].length : 0;
    const termStart = fullIndex + boundaryLen;
    const matchedRaw = m[2];
    if (termStart > cursor) pieces.push(text.slice(cursor, termStart));
    const canonical = terms.find(t => t.toLowerCase() === matchedRaw.toLowerCase()) || matchedRaw;
    const info = glossary.byTerm.get(canonical) || glossary.byTerm.get(canonical.replace(/\s+/g,' '));
    const shown = text.slice(termStart, termStart + matchedRaw.length);
    const definition = info?.definition || (language === 'EN' ? 'No definition available' : 'Sin definición');
    const example = info?.example && info.example.trim().length > 0 ? info.example : null;
    const tooltipNode = (
      <div className="glossary-tooltip-content">
        <div className="glossary-def">{definition}</div>
        {example && (
          <div className="glossary-example"><strong>{exampleLabel}</strong> {example}</div>
        )}
      </div>
    );
    pieces.push(
      <span key={`${termStart}-${canonical}`} className="glossary-term">
        {shown}
        <Tooltip arrow placement="top" title={tooltipNode}>
          <QuestionCircleOutlined className="glossary-icon" style={{ marginLeft: 4, fontSize: '0.95em' }} />
        </Tooltip>
      </span>
    );
    cursor = termStart + matchedRaw.length;
  }
  if (cursor < text.length) pieces.push(text.slice(cursor));
  return pieces.length ? pieces : text;
}
